import { ApiService } from "./api.service";
export default class DefaultTerminologyService extends ApiService {
  namespace = "default-terminology";
  icon = "Lightning";
  name = "Terminology";
  DOMAIN = 302;
  favicon = "Lightning";
  window = 290;
  Width = 690;
  action = "action";

  constructor() {
    super("default-terminologies");
  }
}
